import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'

// export const shape_fields = 'date,shape,degree,peakds,awayds,peakr,slope,waver,maxp,minp,exrp,avgp,midp,grade,index,skiped'
export const shape_fields = 'date,shape,wmaxp,wminp,wavgp,exrp,midp,grade,index,skiped,zdt'
// 字段定义
export const FIELD_SHAPE = DATAS.fieldsToFieldsIndex(shape_fields)
// shape
export function shapeToKbar(indata, shape_zdt) {
    let kbars = []
    let skiped = 0
    let agominp = 0
    for (let index = 0; index < indata.datas.length; index++) {
        kbars.push(
            [CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index)),
                CLAPI.getData(indata, 'shape', index),
                CLAPI.getData(indata, 'wmaxp', index),
                CLAPI.getData(indata, 'wminp', index),
                CLAPI.getData(indata, 'wavgp', index),
                CLAPI.getData(indata, 'exrp', index),
                CLAPI.getData(indata, 'midp', index),
                CLAPI.getData(indata, 'grade', index),
                index,
                0,
                0,
            ])
        let minp = CLAPI.getData(indata, 'wminp', index)
        if (minp > -0.000001 && minp < 0.000001) {
            skiped = 0
        }
        else {
            if (skiped === 1 && agominp == minp) {
                kbars.at(-1)[9] = 1
            }
            skiped = 1
            agominp = minp
        }
        // console.log(minp, kbars.at(-1)[15]);
    }
    if (shape_zdt !== undefined) {
        let index = 0;
        for (let zdtidx = 0; zdtidx < shape_zdt.datas.length; zdtidx++) {
            let zdtdate = CLAPI.Utils.getMsecDate(CLAPI.getData(shape_zdt, 'msec', zdtidx))
            const  shape = CLAPI.getData(shape_zdt, 'shape', zdtidx)
            if (shape !== 0) {
                // console.log(shape)
                for (; index < kbars.length; ) {

                    if (kbars[index][0] == zdtdate) {
                        kbars[index][10] = shape
                        // console.log(kbars[index][0], zdtdate, kbars[index][10]);
                        break
                    }
                    if (kbars[index][0] < zdtdate) {
                        index++
                        continue
                    }
                    if (kbars[index][0] > zdtdate) {
                        break
                    }
                }
            }
        }
    }
    return {
        fields: FIELD_SHAPE,
        datas: kbars
    }
}

export const show_zdp1_lines = [{
    className: CLAPI.ClDrawZLine,
    extremum: { // 如何取极值
        method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        maxvalue: ['exrp'], // 参与计算最大值的标签
        minvalue: ['exrp'] // 参与计算最小值的标签
    },
    info: {
        label: '均价:',
        showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
        filled: true,
        fieldX: 'index',
        fieldY: 'exrp', // 需要显示的变量，从key中获取对应的数据标签
        format: 'float',
    }
}, {
    className: CLAPI.ClDrawZLine,
    extremum: { // 如何取极值
        method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        maxvalue: ['midp'], // 参与计算最大值的标签
        minvalue: ['midp'] // 参与计算最小值的标签
    },
    info: {
        label: '中值:',
        showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
        filled: true,
        fieldX: 'index',
        fieldY: 'midp', // 需要显示的变量，从key中获取对应的数据标签
        format: 'float',
    }
},
{
    className: CLAPI.ClDrawZLine,
    info: {
        fieldX: 'index',
        fieldY: 'wavgp',
        skipfd: 'skiped',
        format: 'float',
        // color : 'lwhite',
    }
},
{
    className: CLAPI.ClDrawZLine,
    info: {
        fieldX: 'index',
        fieldY: 'wminp',
        skipfd: 'skiped',
        format: 'float',
        color : 'green',
    }
},
{
    className: CLAPI.ClDrawZLine,
    info: {
        fieldX: 'index',
        fieldY: 'wmaxp',
        skipfd: 'skiped',
        format: 'float',
        color : 'red',
    }
}]

export const show_zdp2_lines = [{
    className: CLAPI.ClDrawVBar,
    extremum: { // 如何取极值
        method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        maxvalue: ['shape'], // 参与计算最大值的标签
        minvalue: ['shape'] // 参与计算最小值的标签
    },
    info: {
        label: '区间标志:',
        showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
        filled: true,
        fieldX: 'index',
        fieldY: 'shape', // 需要显示的变量，从key中获取对应的数据标签
        format: 'integer',
    }
}]

export const show_zdp3_lines = [{
    className: CLAPI.ClDrawVBar,
    extremum: { // 如何取极值
        method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        maxvalue: ['grade'], // 参与计算最大值的标签
        minvalue: ['grade'] // 参与计算最小值的标签
    },
    info: {
        label: '价格区间:',
        showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
        filled: true,
        fieldX: 'index',
        fieldY: 'grade', // 需要显示的变量，从key中获取对应的数据标签
        format: 'float',
    }
}, ]

export const show_zdp4_lines = [{
    className: CLAPI.ClDrawVBar,
    extremum: { // 如何取极值
        method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        maxvalue: [4], // 参与计算最大值的标签
        minvalue: [-4] // 参与计算最小值的标签
    },
    info: {
        label: '价格区间:',
        showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
        filled: true,
        fieldX: 'index',
        fieldY: 'zdt', // 需要显示的变量，从key中获取对应的数据标签
        format: 'integer',
    }
}, ]

